// @core/api/endpoints/subscription/update_product_bundle.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductBundleResponse,
  UpdateProductBundleRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Update product bundle
 * Updates an existing product bundle's configuration. Changes to pricing only affect new subscriptions.
 */
export async function UpdateProductBundle(
  bundle_id: string,
  data: UpdateProductBundleRequest,
  options?: RequestOptions
): Promise<ProductBundleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bundles/:bundle_id`;
  requestPath = requestPath.replace(':bundle_id', encodeURIComponent(bundle_id));
  const requestOptions = options;
  return client.put<ProductBundleResponse>(requestPath, data, requestOptions);
}
